export interface ISort {
  isSelected: boolean;
  title: string;
  type: ESortType;
}

export enum ESortType {
  /** По дате (сначала новые) **/
  By_date_asc = 'by_date_asc',
  /** По дате (сначала старые) **/
  By_date_desc = 'by_date_desc',
  /** По оценке (сначала низкая) **/
  By_rating_asc = 'by_rating_asc',
  /** По оценке (сначала высокая) **/
  By_rating_desc = 'by_rating_desc',
  /** По умолчанию **/
  Default = 'default',
}
